import styled from 'styled-components';

/**
 * The speaker header row shared by the original-language transcript view
 * (`TranscriptionText`) and the translated one
 * (`TranscriptionTextTranslated`). The two must offer the same entries and
 * the same hover affordance, which separate copies of these rules drift
 * apart on.
 */

/**
 * Header container for speaker label and timestamp
 * Uses flexbox to position label on left and time on right
 * Non-selectable to prevent interference with text selection/deletion
 */
export const SpeakerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  margin-top: 10px;
  user-select: none;
  pointer-events: none;

  &:first-child {
    margin-top: 0;
  }
`;

// FIXME: NEXT
/**
 * Speaker label displayed at speaker change boundaries
 * Styled to match Content Studio appearance
 * `$clickable` re-enables the pointer events the header disables above
 */
export const SpeakerLabel = styled.span<{
  $color?: string;
  $clickable?: boolean;
}>`
  color: ${props => props.$color || 'var(--accent)'};
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  ${props =>
    props.$clickable &&
    `
    pointer-events: auto;
    cursor: pointer;
    padding: 2px 8px;
    margin-left: -8px;
    border-radius: 4px;
    transition: background 0.15s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.12);
    }
  `}
`;

/**
 * Timestamp display for speaker section start time
 * Subtle styling to be indicative but not overwhelming
 */
export const SpeakerTime = styled.span`
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-regular);
`;
